<template>
	<section>
		<header-page
			actions
			name="account-modules"
			:title="title"
			@run-action="runAction"
		/>
		<v-layout tabindex="-1">
			<v-flex>
				<v-alert
				:value="!currentSubsidiary.id" type="warning">
					Seleccione una empresa
				</v-alert>
			</v-flex>
		</v-layout>
		<app-actions :resource-uri="$route.name" @run-action="runAction" />
		<modules-list
			v-if="currentSubsidiary.id"
			:current-page="params.page"
			:last-page="table.lastPage"
			:rows="rows"
			@click-icon="clickIcon"
			@on-page="onPage"
			@on-search="onSearch"
		>
		</modules-list>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				hidden
				success-color="primary"
				success-text="Atras"
				@accept-button-clicked="returnModule"
			></modal-sidebar-button>
		</section>
		<!--<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>!-->
		<action-sidebar
			:title="action.title"
			:value="action.visible"
			@close-modal="closeModal"
		>
			<modules-form
				v-if="isModuleForm"
				:subsidiary-id="subsidiaryId"
				:customer-id="customerId"
				:id="selectedRow.id"
				@close-modal="closeModal"
			/>
			<modules-form-remove
				v-if="isModuleRemove"
				:id="selectedRow.id"
				:name="selectedRow.name"
				@close-modal="closeModal"
			/>
		</action-sidebar>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	ACCOUNTING_MODULES_FORM,
	ACCOUNTING_MODULES_REMOVE,
} from '@/shared/action-codes';
import actionBar from '@/components/shared/action-bar/action-bar';
import actionSidebar from '@/components/shared/action-sidebar';
import backButtonRoute from '@/components/shared/back-button-route';
import modulesList from '@/components/modules/modules-list';
import modulesForm from '@/components/modules/modules-form';
import modulesFormRemove from '@/components/modules/modules-form-remove';
import appActions from '@/components/shared/app-actions/app-actions';

function data() {
	return {
		action: {
			code: '',
			title: '',
			visible: false,
		},
		rows: [],
		selectedRow: {
			id: null,
			customerId: null,
			subsidiaryId: null,
		},
	};
}

async function loadData() {
	this.$set(this.params, 'customerId', this.currentSubsidiary.customerId);
	this.$set(this.params, 'subsidiaryId', this.currentSubsidiary.id);
	const { records } = await this.loadData('type-register?flagActive=1');
	this.rows = records
		.map(({ id, code, name }) => ({ code, name, id }))
		.filter(record => record.name === 'COMPRAS' || record.name === 'VENTAS');
	return this.rows;
}

function clickIcon({ action, row }) {
	this.selectedRow.customerId = row.customerId;
	this.selectedRow.subsidiaryId = row.subsidiaryId;
	this.selectedRow.id = row.id;
	this.selectedRow.name = row.name;
	if (action === 'edit') {
		this.action.title = `Editar - ${row.name}`;
		this.action.code = ACCOUNTING_MODULES_FORM;
		this.action.visible = true;
	} else if (action === 'delete') {
		this.action.code = ACCOUNTING_MODULES_REMOVE;
		this.action.title = `Eliminar - ${row.name}`;
		this.action.visible = true;
	} else if (action === 'dictionary') {
		this.goTo('accounting-dictionary-ats', {
			query: {
				customerId: this.currentSubsidiary.customerId,
				id: this.selectedRow.id,
				name: this.selectedRow.name,
				subsidiaryId: this.currentSubsidiary.id,
			},
		});
	}
}

function closeModal(reloadList) {
	this.action.code = '';
	this.action.title = '';
	this.action.visible = false;
	this.selectedRow.id = 0;
	if (reloadList) {
		loadData.call(this);
	}
}

async function created() {
	await loadData.call(this);
}

function customerId() {
	return Number(this.$route.query.customerId);
}

function isModuleForm() {
	return this.action.code === ACCOUNTING_MODULES_FORM;
}

function isModuleRemove() {
	return this.action.code === ACCOUNTING_MODULES_REMOVE;
}

async function onPage(page) {
	this.params.page = page;
	await loadData.call(this);
}

async function onSearch(value) {
	this.params.page = 1;
	this.$set(this.params, 'search', value || null);
	await loadData.call(this);
}

function runAction({ name, code }) {
	this.action.title = name;
	this.action.code = code;
	this.action.visible = true;
	this.selectedRow.id = 0;
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}

function title() {
	return `${this.$route.query.name} / ${this.$route.meta.title}`;
}

function returnModule() {
	this.$router.go(-1);
}

function currentSubsidiary(newSub) {
	const { id, name, customerId: idCustomer } = newSub;
	this.goTo('accouting-diccionary', {
		query: {
			subsidiaryId: id,
			name: name.split(' ').join('-'),
			customerId: idCustomer,
		},
	});
}

function routeHandler() {
	loadData.call(this);
}

export default {
	name: 'accouting-diccionary',
	created,
	components: {
		actionBar,
		appActions,
		actionSidebar,
		modulesForm,
		modulesList,
		modulesFormRemove,
		backButtonRoute,
	},
	computed: {
		...mapGetters('subsidiary', ['currentSubsidiary']),
		customerId,
		isModuleForm,
		isModuleRemove,
		subsidiaryId,
		title,
	},
	data,
	methods: {
		clickIcon,
		closeModal,
		onPage,
		onSearch,
		returnModule,
		routeHandler,
		runAction,
	},
	watch: {
		'$route.params': routeHandler,
		currentSubsidiary,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/atsDictionary/ats-modules.vue